class VideoGallery {
    constructor() {
        this.modalOpen = false;
        this.modal = document.getElementById('modal');
        this.modalBackdrop = document.querySelector('.modal-backdrop');
        this.videoButton = document.querySelector('.video_link');
        this.video = document.querySelector('#modal video');
        
        this.init();
    }

    init() {
        // Open modal (only if button exists)
        if (this.videoButton) {
            this.videoButton.addEventListener('click', () => this.openModal());
        }

        // Close modal on backdrop click (only if backdrop exists)
        if (this.modalBackdrop) {
            this.modalBackdrop.addEventListener('click', () => this.closeModal());
        }
        
        // Close modal on escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.modalOpen) {
                this.closeModal();
            }
        });

        // Close modal on outside click (only if modal exists)
        if (this.modal) {
            this.modal.addEventListener('click', (e) => {
                if (e.target === this.modal) {
                    this.closeModal();
                }
            });
        }
    }

    openModal() {
        this.modalOpen = true;
        this.modal.style.display = 'flex';
        this.modalBackdrop.style.display = 'block';
        document.body.style.overflow = 'hidden';
        
        if (this.video) {
            this.video.querySelectorAll('source[data-src]').forEach((s) => {
                s.src = s.dataset.src;
                s.removeAttribute('data-src');
            });
            if (this.video.readyState === 0) this.video.load();
            this.video.play().catch(() => {});
        }
    }

    closeModal() {
        this.modalOpen = false;
        this.modal.style.display = 'none';
        this.modalBackdrop.style.display = 'none';
        document.body.style.overflow = '';
        
        if (this.video) {
            this.video.pause();
            this.video.querySelectorAll('source[src]').forEach((s) => {
                s.dataset.src = s.src;
                s.removeAttribute('src');
            });
            this.video.removeAttribute('src');
            this.video.load();
        }
    }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    new VideoGallery();
});
